module.exports = __webpack_public_path__ + "img/fullinsight.af6bb4f3.svg";